var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsInt, IsOptional, Min } from 'class-validator';
import { SlotSearchWarningCode } from '../enums/slot-search-warning-code.enum.js';
export class SlotSearchWarningDto {
    code;
    /**
     * For `SCATTERED_ACROSS_THERAPISTS`: how many distinct therapists the
     * fallback assembly distributed the series across (>= 1). Absent for codes
     * that do not need it.
     */
    therapistCount;
}
__decorate([
    IsEnum(SlotSearchWarningCode),
    __metadata("design:type", String)
], SlotSearchWarningDto.prototype, "code", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], SlotSearchWarningDto.prototype, "therapistCount", void 0);
//# sourceMappingURL=slot-search-warning.dto.js.map